import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import './styles/index.css';
import './fonts/WorkSans-Bold.woff2';
import './fonts/WorkSans-Regular.woff2';
import './fonts/JetBrainsMono-Regular.woff2';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
